import measuringIcon from '@/assets/icons/Measuring.svg'
import crowdIcon from '@/assets/icons/crowd.svg'
import alertIcon from '@/assets/icons/alert.svg'
import weatherIcon from '@/assets/icons/weather.svg'
import type { IndustryPageContent } from './types'

// Copy: content/unimo-industry-page-copy.md, "FACILITIES" — signed off 28 Aug 2026.
// Stats/citations: content/unimo-industry-stats.md v7 (final) — same date.
// Hero headline is the only thing carried over from the old live page at
// src/features/industries/FacilitiesPage.tsx — nothing else from it.
export const facilitiesContent: IndustryPageContent = {
    key: 'facilities',
    hero: {
        headlineLine1: 'Smarter Buildings.',
        headlineLine2: 'Complete Visibility.',
    },
    statBand: {
        header: 'What facilities managers are up against.',
        stats: [
            {
                figure: '16',
                unit: '°C',
                body: "is the minimum temperature your building should hit. There's no maximum. Yet.",
                citation: 1,
            },
            {
                figure: '81',
                unit: '%',
                body: 'of commercial buildings sit below EPC B.',
                citation: 2,
            },
            {
                figure: '11.3',
                unitPhrase: 'billion kWh',
                body: "across the NHS estate in a year. At that scale, you don't find waste by looking for it.",
                citation: 3,
            },
        ],
    },
    usps: [
        {
            title: 'Energy monitoring',
            body: 'Real-time power consumption by zone, floor or circuit. Identify waste, optimise HVAC and track against sustainability targets.',
            icon: measuringIcon,
        },
        {
            title: 'Occupancy analytics',
            body: 'See how your space actually gets used. Real utilisation by floor, zone and time, with heat maps that show where people gather and what sits empty. GDPR-compliant, no personal data.',
            icon: crowdIcon,
        },
        {
            title: 'Access control',
            body: 'Catch what badge systems miss. AI vision flags tailgating, loitering and entry into restricted zones, working alongside your existing access setup rather than replacing it.',
            icon: alertIcon,
        },
        {
            title: 'Environmental quality',
            body: 'CO2, temperature, humidity and air quality monitoring. Ensure comfort and compliance with workplace standards.',
            icon: weatherIcon,
        },
    ],
    closingCta: {
        headline: 'Ready for fewer surprises?',
    },
    references: [
        {
            id: 1,
            text: 'House of Commons Library, Working in hot weather: What does the law say?, CBP-10925, 2026.',
            italicPhrase: 'Working in hot weather: What does the law say?',
            url: 'https://commonslibrary.parliament.uk/research-briefings/cbp-10925/',
            linkLabel: 'commonslibrary.parliament.uk',
        },
        {
            id: 2,
            text: 'British Property Federation, annual analysis of EPC ratings in major English cities, 2026.',
            url: 'https://bpf.org.uk',
            linkLabel: 'bpf.org.uk',
        },
        {
            id: 3,
            text: 'NHS England, Estates Returns Information Collection (ERIC) 2024/25, 2025.',
            italicPhrase: 'Estates Returns Information Collection (ERIC) 2024/25',
            url: 'https://digital.nhs.uk/data-and-information/publications/statistical/estates-returns-information-collection/summary-page-and-dataset-for-eric-2024-25',
            linkLabel: 'digital.nhs.uk',
        },
    ],
}

export default facilitiesContent
